// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup .pick-item {
  padding: 50px 20px 20px 20px;
  min-height: 250px;
}
.popup .pick-item h2 {
  font: 2em/1 vigaregular;
  text-align: left;
  color: #5c5c5c;
  margin-bottom: 6%;
}
.popup .pick-item .item-product {
  width: 100%;
  padding: 0 5px;
  text-align: center;
}
.popup .pick-item .item-product figure {
  text-align: center;
  display: inline-block;
  overflow: hidden;
  height: 180px;
  width: 180px;
}
.popup .pick-item .item-product img {
  transform: translateX(-50%);
  position: absolute;
  height: 100%;
  width: auto;
  left: 50%;
}
.popup .pick-item .item-product span {
  color: #caa36c;
  font: 1.4em/1 vigaregular;
}
.popup .pick-item .item-product .btn-primary {
  font: 1.4em/1 vigaregular;
  width: 100%;
}
.popup .pick-item .rec.rec-carousel-wrapper .rec-carousel {
  max-height: 240px;
}
.popup .pick-item .rec.rec-carousel-wrapper .rec.rec-pagination {
  border-top: 1px solid #f2f2f2;
  padding-top: 10px;
  /*margin-top: -10px;*/
}
.popup .pick-item .rec.rec-carousel-wrapper .rec.rec-pagination .rec-dot {
  width: 5px;
  height: 5px;
  margin: 2px;
}
.popup .pick-item .rec.rec-carousel-wrapper .rec-arrow {
  color: #caa36c;
  background: none;
  box-shadow: none;
}
.popup .pick-item .rec.rec-carousel-wrapper .rec-arrow:hover {
  color: #caa36c;
  background: none;
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/popups/PickItemContent.scss"],"names":[],"mappings":"AACI;EACI,4BAAA;EACA,iBAAA;AAAR;AAEQ;EACI,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAAZ;AAGQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;AADZ;AAEY;EACI,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;AAAhB;AAEY;EACI,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AAAhB;AAEY;EACI,cAAA;EACA,yBAAA;AAAhB;AAEY;EACI,yBAAA;EACA,WAAA;AAAhB;AAIY;EACI,iBAAA;AAFhB;AAIY;EACI,6BAAA;EACA,iBAAA;EACA,qBAAA;AAFhB;AAGgB;EACI,UAAA;EACA,WAAA;EACA,WAAA;AADpB;AAKY;EACI,cAAA;EACA,gBAAA;EACA,gBAAA;AAHhB;AAIgB;EACI,cAAA;EACA,gBAAA;EACA,gBAAA;AAFpB","sourcesContent":[".popup {\n    .pick-item {\n        padding: 50px 20px 20px 20px;\n        min-height: 250px;\n\n        h2 {\n            font: 2em/1 vigaregular;\n            text-align: left;\n            color: #5c5c5c;\n            margin-bottom: 6%;\n        }\n\n        .item-product{\n            width: 100%;\n            padding: 0 5px;\n            text-align: center;\n            figure{\n                text-align: center;\n                display: inline-block;\n                overflow: hidden;\n                height: 180px;\n                width: 180px;\n            }\n            img{\n                transform: translateX(-50%);\n                position: absolute;\n                height: 100%;\n                width: auto;\n                left: 50%;\n            }\n            span{\n                color: #caa36c;\n                font: 1.4em/1 vigaregular;\n            }\n            .btn-primary{\n                font: 1.4em/1 vigaregular;\n                width: 100%;\n            }\n        }\n        .rec.rec-carousel-wrapper{\n            .rec-carousel{\n                max-height: 240px;\n            }\n            .rec.rec-pagination{\n                border-top: 1px solid #f2f2f2;\n                padding-top: 10px;\n                /*margin-top: -10px;*/\n                .rec-dot{\n                    width: 5px;\n                    height: 5px;\n                    margin: 2px;\n                }\n            }\n            \n            .rec-arrow{\n                color: #caa36c;\n                background: none;\n                box-shadow: none;\n                &:hover{\n                    color: #caa36c;\n                    background: none;\n                    box-shadow: none;\n                }\n            }\n        }\n       \n        \n\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
